import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonsModule } from '../../commons/commons.module';
import { PagesComponentsModule } from '../components/pages-components.module';
import { FeedbackProcessPagesComponent } from './feedback-process-pages.component';

@NgModule({
  declarations: [FeedbackProcessPagesComponent],
  imports: [CommonModule, CommonsModule, PagesComponentsModule],
})
export class FeedbackProcessPagesModule {}
